import BaseService from "./BaseService";

class ShippingTypeService {
  static async GetShippingTypes(tennantId, token) {
    try {
      return await BaseService.get("shippingtypes", token, { tennantId });
    } catch (error) {
      console.error("There was an error fetching the shipping types!", error);
      throw error;
    }
  }
}

export default ShippingTypeService;
